// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qJ-z","twoColumnImage":"rJ-z"};